import { Builder } from '@builder.io/react';

import SolutionsHero from './index';

Builder.registerComponent(SolutionsHero, {
  name: 'SolutionsHero',
  inputs: [
    {
      name: 'logo',
      type: 'string',
      enum: [
        'selfLottie',
        'self',
        'drones',
        'robotics',
        'roboticsLottie',
        'ar',
        'arLottie',
        'retail'
      ]
    },
    {
      name: 'title',
      type: 'object',
      subFields: [
        {
          name: 'normal',
          type: 'string'
        },
        {
          name: 'strong',
          type: 'string'
        }
      ]
    },
    {
      name: 'subtitle',
      type: 'longText'
    },
    {
      name: 'heroColor',
      type: 'object',
      subFields: [
        {
          name: 'bg',
          type: 'color',
          defaultValue: '#ffffff'
        },
        {
          name: 'width',
          type: 'number'
        }
      ]
    },
    {
      name: 'slides',
      type: 'list',
      defaultValue: [
        {
          epigraph: 'epigraph',
          src: '/'
        }
      ],
      subFields: [
        {
          name: 'epigraph',
          type: 'string'
        },
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['svg']
        }
      ]
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Talk to us',
              href: '/sales',
              type: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        }
      ]
    }
  ]
});
